import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installClientErrorReporting } from "@shared/clientErrors";
// Relative, not "@shared/..." - the standalone foyer-guest build aliases
// @shared to foyer-shared/dist (tsc output: no CSS, no font files).
import "../shared/fonts/scheme.css";
import "./styles.css";

// Uncaught errors and unhandled rejections go to POST /api/client-errors,
// grouped server-side and listed under Settings > Client errors. Installed
// before render so a crash in the first render is caught too.
installClientErrorReporting(
  "guest",
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev"
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for offline re-open. Non-blocking; failures are
// silent (the app works fine without it).
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
